import styled from 'styled-components';
interface BreadcrumbChildProps {
  active?: boolean;
}

export const BreadcrumbChild = styled('li')<BreadcrumbChildProps>`
  display: inline-block;
  padding-right: ${({ theme }) => theme.x1space}rem;
  position: relative;
  > a {
    ${({ theme }) => theme.typography.xSmall}
    text-decoration: ${({ active }) => (active ? 'none' : 'underline')};
    &:hover {
      color: ${({ theme, active }) => active && theme.color.whiteRGBA(0.8)};
    }
  }
  > span {
    ${({ theme }) => theme.typography.xSmall}
  }
`;
